import React, { Component } from 'react';
import { Button, message, DatePicker, Modal, Radio, Tooltip, Icon } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const RadioGroup = Radio.Group;
const { MonthPicker } = DatePicker
const monthFormat = 'YYYY-MM';
let yearMonth = moment().format(monthFormat)

class Filter extends Component {
    handleChange = (params, key) => {
        // params.beginDate = moment(params.beginDate).format(monthFormat);
        // params.endDate = moment(params.endDate).format(monthFormat);
        // if(Math.abs(moment(params.beginDate).diff(params.endDate,'M')) > 11 || moment(params.beginDate).diff(params.endDate,'M') > 0){
        //     params.endDate = moment(params.beginDate).format(monthFormat);
        // }
        this.props.onChange(params, key);
    }

    saveProvince = (checkedArea) => {
        const { params, onChange } = this.props;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        onChange({
            ...params,
            areaParams,
            areaName: areaList.join(','),
        });
    }

    disabledDate = (current, key) => {
        const { params } = this.props;
        const currentValue = current.valueOf();
        if ( key == 'beginDate'){
            return current && (currentValue < moment(params.endDate).add(-11, 'M') || currentValue > moment(params.endDate));
        }else {
            return current && ( currentValue < moment(params.beginDate) || currentValue > moment(params.beginDate).add(11, 'M') );
        }
    };

    render() {
        const { positionOption, ...rest } = this.props;
        const joinMonthCountOption = []
        for ( var i = 1; i < 13; i++){
            joinMonthCountOption.push({ value: i , label: i })
        }
        const filters = []
        filters.push({
            name: '统计时间',
            key: 'beginDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '~',
            key: 'endDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                // disabledDate:current => this.disabledDate(current, 'endDate'),
            }
        }, {
            name: '入职月份数',
            key: 'joinMonthCount',
            type: 'select',
            typeProperty: {
                list: joinMonthCountOption,
                allowClear: true,
            }
        }, {
            name:'区域/城市',
            key: 'cityIds',
            type: 'selectProvince',
            typeProperty: {
                saveProvince:this.saveProvince
            }
        }, {
            name: '职位',
            key: 'positionName',
            type: 'select',
            typeProperty: {
                style:{ width: 140 },
                list: positionOption,
                allowClear: true,
            }
        }, {
            name: '人员',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                allowClear: true,
                style: { width: 140 },
                params: { limit: 20 },
                placeholder: "输入姓名/工号检索",
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        });
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class NewOutPut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            visible: false,
            sortParams: {},
            positionList:[],
            exportTime:null,
            exportMaxTime:null,
            searchParams: {
                beginDate: `${yearMonth}`,
                endDate: `${yearMonth}`,
                areaParams:{},
            },
            curParams: {
                beginDate: `${yearMonth}`,
                endDate: `${yearMonth}`,
                areaParams:{},
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
        }
    }


    componentDidMount() {
        this.loadData();
        this.queryCrcPosition()
    }

    queryCrcPosition = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryCrcPosition,
            data: { type: 'byDate' },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    positionList:res.data.filter( el => { return el !== '高级临床协调员III'} )
                })
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const params = this.splitParams(curParams);
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryNewEmpOutPutList,
            data: {
                offset: current,
                limit: pageSize,
                ...curParams.areaParams,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount, data:{ maxYearMonth } } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    exportTime:moment(`${maxYearMonth}`).format(monthFormat),
                    exportMaxTime:moment(`${maxYearMonth}`).format(monthFormat),
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }
    
    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        const { beginDate, endDate } = searchParams;
        if (beginDate && endDate) {
            if (moment(beginDate).valueOf() > moment(endDate).valueOf()) {
                return message.warning('开始时间不能大于结束时间')
            }
            if (moment(beginDate).valueOf() < moment(endDate).add(-11, 'M').valueOf() ) {
                return message.warning('时间范围不能超过一年')
            }
        }
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const params = this.splitParams(curParams);
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportUserOutPutList,
            data: {
                ...curParams.areaParams,
                ...sortParams,
                ...params,
                offset: 1,
                type:'newEmpOutPut',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    exportSolidify = () => {
        const { exportTime } = this.state;
        if(!exportTime) {
            message.error('请选择导出固化月份！')
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportUserOutPutList,
            data: {
                beginDate:exportTime,
                endDate:exportTime,
                type:'newEmpOutPutRecord',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.onCancel()
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '统计时间',
            dataIndex: 'yearMonthStr',
            key: 'yearMonthStr',
            fixed: 'left',
            width: 120,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 160,
        }, {
            title: '科室名称',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 160,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 100,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 100,
        }, {
            title: '主管姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 100,
        }, {
            title: '主管工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 100,
        }, {
            title: '主管工作城市所属区域',
            dataIndex: 'leaderAreaName',
            key: 'leaderAreaName',
            width: 100,
        }, {
            title: '主管工作城市',
            dataIndex: 'leaderCityName',
            key: 'leaderCityName',
            width: 100,
        }, {
            title: 'CRC姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 100,
        }, {
            title: 'CRC工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 120,
        }, {
            title: '职位',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'workStatusShow',
            key: 'workStatusShow',
            width: 80,
        }, {
            title: '工作城市所属区域',
            dataIndex: 'crcAreaName',
            key: 'crcAreaName',
            width: 100,
        }, {
            title: '工作城市',
            dataIndex: 'crcCityName',
            key: 'crcCityName',
            width: 100,
        }, {
            title: '入职日期',
            dataIndex: 'joinTimeStr',
            key: 'joinTimeStr',
            width: 100,
        }, {
            title: '入职月份数',
            dataIndex: 'joinMonthCount',
            key: 'joinMonthCount',
            width: 100,
        }, {
            title: '离职日期',
            dataIndex: 'leftTimeStr',
            key: 'leftTimeStr',
            width: 100,
        }, {
            title: '工作周期（h）',
            dataIndex: 'workHour',
            key: 'workHour',
            width: 100,
        }, {
            title: 'CRC确认FTE',
            dataIndex: 'confirmFte',
            key: 'confirmFte',
            width: 100,
        }, {
            title: '完成访视数',
            dataIndex: 'visitCount',
            key: 'visitCount',
            width: 100,
        }, {
            title: '已确认标准访视数',
            dataIndex: 'standardVisitCount',
            key: 'standardVisitCount',
            width: 100,
        }, {
            title: '访视效率',
            dataIndex: 'visitRate',
            key: 'visitRate',
            width: 100,
        }, {
            title: '人员产出率',
            dataIndex: 'outPutRate',
            key: 'outPutRate',
            width: 100,
            render: text => (text || text == 0) ? `${text}%` : ''
        }];
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    exportModalShow = () => {
        this.setState({ visible:true })
    }

    onCancel = () => {
        const { exportMaxTime } = this.state;
        this.setState({ visible: false, exportTime: exportMaxTime })
    }

    exportTimeChange = (date, datestr) => {
        this.setState({ exportTime: datestr })
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams, visible, positionList, exportTime, exportMaxTime } = this.state;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            paddingLeft: '30px',
        };
        const positionOption = [];
        positionList.forEach( el => {
            positionOption.push({  value: el, label: el })
        })
        return (
            <div>
                <div className="reportTitle">{this.props.title}
                    <Tooltip placement="right" title={'入职月份数≤12'}>
                        <Icon style={{ margin: '0 5px', color: '#1296db'}} type="exclamation-circle" />
                    </Tooltip>
                </div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    positionOption={positionOption}
                    buttons={[
                        <Button key="export" type="primary" onClick={ this.export } style={{marginLeft: 8}}>导出</Button>,
                        <Button key="exportSolidify" style={{ marginLeft: 8, backgroundColor:'#ffcc00', color: '#fff', borderColor:'#ffcc00'}} onClick={ () => this.setState({visible:true})}>导出固化数据</Button>
                    ]}
                />
                {/* <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div> */}
                <TableC
                    data={data}
                    loading={loading}
                    className="crcMonthInGroup"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <Modal
                    title='导出固化数据'
                    visible={visible}
                    maskClosable={false}
                    width={350}
                    onOk={this.exportSolidify}
                    onCancel={this.onCancel}
                >
                    <div>
                        <label style={{marginRight: 20}}>请选择固化月份</label>
                        <MonthPicker 
                            value={exportTime ? moment(exportTime) : null} 
                            placeholder="请选择" 
                            onChange={ this.exportTimeChange }
                            disabledDate={(current) => { return current && current.valueOf() > moment(exportMaxTime) }}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

export default NewOutPut;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/newOutPut.js